
































































import { Component, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import JobsearchApplicationSearchBox from "@/components/jobsearch/JobsearchApplicationSearchBox.vue";
import { JobsearchApplicationSearchParams } from "@/components/jobsearch/JobsearchApplicationSearchBox.vue";

import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import JobsearchApplicationTable from "@/views/jobsearch/JobsearchApplicationTable.vue";
import { PortalJobsearchApplication } from "@/model/portal";

@Component({
  components: {
    AppTextField,
    JobsearchApplicationSearchBox,
    AppAuthButton,
    JobsearchApplicationTable,
  },
})
export default class extends Mixins(AxiosMixin) {
  private searchKey = ""; //絞り込み文字列

  /** タブ情報 */
  private currentTab = 0;

  private newApplications: PortalJobsearchApplication[] = [];
  private activeApplications: PortalJobsearchApplication[] = [];
  private endApplications: PortalJobsearchApplication[] = [];

  private fetchList(searchObj: JobsearchApplicationSearchParams): void {
    this.postJsonCheck(
      window.base_url + "/api/admin/portal_jobsearch_applications/get",
      searchObj,
      (res) => {
        this.newApplications = res.data.new_applications || [];
        this.activeApplications = res.data.active_applications || [];
        this.endApplications = res.data.end_applications || [];
      }
    );
  }
}
